// @core/api/endpoints/signature/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CreateParty } from './create_party';
import { CreateSignature } from './create_signature';
import { CreateSignatureRequest } from './create_signature_request';
import { DeleteParty } from './delete_party';
import { GetParty } from './get_party';
import { GetSignature } from './get_signature';
import { GetSignatureRequest } from './get_signature_request';
import { ListParties } from './list_parties';
import { ListPartiesByTarget } from './list_parties_by_target';
import { ListSignatureRequestsByTarget } from './list_signature_requests_by_target';
import { ListSignaturesByTarget } from './list_signatures_by_target';
import { PrepareSigning } from './prepare_signing';
import { SubmitSignature } from './submit_signature';
import { UpdateParty } from './update_party';
import { ValidateSignature } from './validate_signature';

// Re-export individual endpoints
export {
  CreateParty,
  CreateSignature,
  CreateSignatureRequest,
  DeleteParty,
  GetParty,
  GetSignature,
  GetSignatureRequest,
  ListParties,
  ListPartiesByTarget,
  ListSignatureRequestsByTarget,
  ListSignaturesByTarget,
  PrepareSigning,
  SubmitSignature,
  UpdateParty,
  ValidateSignature,
};

// Namespace export for convenient usage
export const signatureApi = {
  CreateParty,
  CreateSignature,
  CreateSignatureRequest,
  DeleteParty,
  GetParty,
  GetSignature,
  GetSignatureRequest,
  ListParties,
  ListPartiesByTarget,
  ListSignatureRequestsByTarget,
  ListSignaturesByTarget,
  PrepareSigning,
  SubmitSignature,
  UpdateParty,
  ValidateSignature,
};
